<template lang="html">
    <div id="page__users" class="center-panel">
        <md-content md-theme="white" v-bind:loading="progress">
            <user-menu></user-menu>
            <sort-table
                v-bind:columns="tableColumns" v-model="users" v-on:refresh="getUsers" v-bind:per-page="perPage" 
                v-bind:total="usersAmount" table-id="users" v-on:create="addUser" tableHeight="calc(100% - 48px)" link
            >
                <template slot="last_login" slot-scope="scope">
                    <span v-if="scope.item.last_login"> {{moment(scope.item.last_login).format('DD.MM.YYYY HH:mm')}}</span>
                </template>

                <template slot="is_blocked" slot-scope="scope">
                    <span>{{ parseInt(scope.item.is_blocked) === 1 ? 'Заблокирован' : 'Не заблокирован' }}</span>
                </template>

                <template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" v-on:click.stop.prevent="onRemove(scope.item.id)" danger-light rounded></z-icon-button>
                </template>
                <template slot="groups" slot-scope="scope">
                    <div class="chips">
                        <div class="chip" v-for="item in scope.item.groups">{{item.name}}</div>
                    </div>
                </template>
            </sort-table>
        </md-content>
    </div>
</template>
<script>
    import UserMenu    from './menu.vue';
    import SortTable   from "@/components/SortTable";
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: {UserMenu, SortTable, ZIconButton},
        data() {
            return {
                tableColumns: [
                    { label: 'ID', field: 'id', default: true, sortable: true },
                    { label: 'ФИО', field: 'fio', sortable: true },
                    { label: 'Логин', field: 'login', sortable: true },
                    { label: 'Группа', field: 'groups', sortable: false },
                    { label: 'Склад', field: 'stocks', sortable: false },
                    { label: 'Блокировка', field: 'is_blocked', sortable: true },
                    { label: 'Поседняя активность', field: 'last_login', sortable: false },
                    { label: '', field: 'actions' },
                ],
                title: 'Пользователи',
                perPage: 50
            }
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['get-users-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
            /**
             * Список пользователей
             */
            users() {
                return this.$store.state.users.users.map(user => {
                    user.routerLink = {name: 'User', params: {user_id: user.id}, query: this.$route.query};
                    return user;
                });
            },
            /**
             * Количество пользователей
             */
            usersAmount() {
                return this.$store.state.users.users_amount;
            }
        },
        created() {
            this.$store.commit('setTitle', 'Пользователи')
        },
        methods: {
            /**
             * Добавление пользователя
             */
            addUser() {
                this.$router.push({ name: 'User', params: {user_id: 'new'} });
            },
            /**
             * Удаление пользователя
             */
            removeUser(id) {
                if (!id) return;
                this.$store.commit('showProgressBar', 'get-users-list');
                this.$store.dispatch('users/removeUser', id)
                    .then(() => this.$root.$emit('refresh-table', 'users'))
                    .finally(() => this.$store.commit('hideProgressBar', 'get-users-list'));
            },
            /**
             * Модальное окно с подтверждением удаления пользователя
             */
            onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении пользователя?', 'Действие необратимо!',
                    () => this.removeUser(id)
                );
            },
            /**
             * Получение пользователей
             */
            getUsers(page, perPage, sortBy, sortOrder) {
                this.$store.commit('showProgressBar', 'get-users-list');
                this.$store.dispatch('users/getUsers', {
                    order_by:   sortBy,
                    order_type: sortOrder,
                    page:   page,
                    count:  perPage,
                    filter: this.resolveQueryFilter()
                }).finally(() => this.$store.commit('hideProgressBar', 'get-users-list'));
            },
            /**
             * Вытаскивает фильтр из URL и форматирует его в коррктный вид для запроса, в формате:
             * {model: [['field', 'condition', 'value'], 'and|or', ['field', 'condition', 'value']]}
             */
            resolveQueryFilter() {//переименовать overview
                if (!this.$route.query || !this.$route.query.filter) return null;
                let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), result = {model: [], relation: [], condition: 'and'};
                
                if (filter.search) result.model = [
                    ['login', '%', filter.search], 'or',
                    ['fio', '%', filter.search]
                ];

                if (filter.group_id) result.relation.push(['groups', 'id', '=', filter.group_id]);
                
                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// Users.vue?01d886ab